export const environment = {
  "production": false,
  "info":  "Collaudo",
  "baseUrl": "https://portal-clamor.app24pa.it/rest",
  "oauthClient": "app24pa-col-oauth",
  "oauthSecret": "App24PA-v1-secret"
};
